/* TC PREMIUM LAYER JS — 2026-10-28. Reveal on scroll, parallax, desktop cursor,
   magnetic buttons. Everything degrades to a normal page if this file fails:
   the hide-until-revealed CSS only applies under html.tc-js, which this adds. */
(function(){
  var d = document, de = d.documentElement;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  de.classList.add('tc-js'); window.__tcP = true;

  /* ---- reveal ---- */
  function tagGrids(){
    [].forEach.call(d.querySelectorAll('.tc-grid'), function(g){
      [].forEach.call(g.children, function(c, i){ c.style.setProperty('--d', i % 4); c.setAttribute('data-reveal-child',''); });
    });
    [].forEach.call(d.querySelectorAll('.tc-section__head, .tc-promo .tc-container, .tc-ss__card, .tc-truck__copy'), function(el){
      if(!el.hasAttribute('data-reveal')) el.setAttribute('data-reveal','');
    });
  }
  tagGrids();
  var targets = d.querySelectorAll('[data-reveal], [data-reveal-child]');
  if(reduce || !('IntersectionObserver' in window)){
    [].forEach.call(targets, function(t){ t.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    [].forEach.call(targets, function(t){ io.observe(t); });
    /* safety: anything still hidden after 2.5s is shown (e.g. very tall elements) */
    setTimeout(function(){ [].forEach.call(d.querySelectorAll('[data-reveal]:not(.is-in)'), function(t){ var r = t.getBoundingClientRect(); if(r.top < innerHeight) t.classList.add('is-in'); }); }, 2500);
  }

  var fine = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---- parallax: [data-parallax="0.12"] ---- */
  var px = [].slice.call(d.querySelectorAll('[data-parallax]'));
  if(px.length && !reduce){
    var ticking = false;
    function run(){
      ticking = false; var vh = innerHeight;
      px.forEach(function(el){
        var r = el.getBoundingClientRect(); if(r.bottom < -200 || r.top > vh + 200) return;
        var k = parseFloat(el.getAttribute('data-parallax')) || .1;
        if(innerWidth < 700) k = k * .5;
        var off = (r.top + r.height/2 - vh/2) * -k;
        el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
      });
    }
    addEventListener('scroll', function(){ if(!ticking){ ticking = true; requestAnimationFrame(run); } }, {passive:true});
    run();
  }

  /* ---- cursor ---- */
  if(fine && !reduce){
    var c = d.createElement('div'); c.className = 'tc-cursor'; c.innerHTML = '<span></span>';
    d.body.appendChild(c); var lab = c.firstChild;
    var x = -100, y = -100, cx = -100, cy = -100;
    addEventListener('mousemove', function(e){ x = e.clientX; y = e.clientY; c.classList.add('is-on'); }, {passive:true});
    d.addEventListener('mouseleave', function(){ c.classList.remove('is-on'); });
    (function loop(){ cx += (x - cx) * .22; cy += (y - cy) * .22; c.style.transform = 'translate3d(' + cx + 'px,' + cy + 'px,0)'; requestAnimationFrame(loop); })();
    d.addEventListener('mouseover', function(e){
      var t = e.target.closest && e.target.closest('[data-cursor], .tc-card, .tc-truck__card');
      if(t){ lab.textContent = t.getAttribute('data-cursor') || 'View'; c.classList.add('is-big'); }
      else c.classList.remove('is-big');
    });
  }

  /* ---- magnetic buttons ---- */
  if(fine && !reduce){
    [].forEach.call(d.querySelectorAll('.tc-p-btn, .tc-btn'), function(b){
      b.addEventListener('mousemove', function(e){ var r = b.getBoundingClientRect(); var mx = (e.clientX - r.left - r.width/2) * .18, my = (e.clientY - r.top - r.height/2) * .3; b.style.transform = 'translate(' + mx + 'px,' + my + 'px)'; });
      b.addEventListener('mouseleave', function(){ b.style.transform = ''; });
    });
  }
  /* ---- lux header (2026-10-29): on the homepage the header is see-through over the film,
     and turns white once you scroll or hover it (tc-lux.css, html.tc-lux-home) ---- */
  var hs = d.getElementById('shopify-section-header');
  if(hs && de.classList.contains('tc-lux-home')){
    var hov = false;
    function solid(){ hs.classList.toggle('tc-solid', scrollY > 12 || hov); }
    addEventListener('scroll', solid, {passive:true});
    hs.addEventListener('mouseenter', function(){ hov = true; solid(); });
    hs.addEventListener('mouseleave', function(){ hov = false; solid(); });
    solid();
  }

  /* ---- rack: when a shirt comes off the rack, bring the whole rack into view ---- */
  d.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-rack-open]'); if(!b) return;
    var r = b.closest('.tc-rack'); if(!r) return;
    setTimeout(function(){
      var bb = r.getBoundingClientRect(), top = 72;
      if(bb.top < top || bb.bottom > innerHeight){
        var y = scrollY + bb.top - Math.max(top, (innerHeight - bb.height) / 2);
        window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
      }
    }, 30);
  });
})();
